import * as tools from "../helpers/Tools";
import { v4 as uuidv4 } from 'uuid';

export const gaAddToCart = (eventType, productId, productName, position, list, category, patientStatus, brand) => {
    window.dataLayer.push({ ecommerce: null }); //Clear the previous ecommerce object.
    window.dataLayer.push({
      event: eventType,
      ecommerce: {
        currencyCode: "USD",
        add: {
          actionField: {
            list:list,
          },
          products: [
            {
              id: productId,
              name: productName,
                  category: category,
                  dimension3: patientStatus,
              brand: brand,
              position: position, //index location API response ID
              quantity: 1, //total Loc count
              price: 0,
            },
          ],
        },
      },
    });
  };
  
export const gaCheckout = (eventType, pID, pName, locId, position, list, category, brand, variant, step, patientStatus, aptDate) => {
    const product = {
        id: pID,
        name: pName,
        category: category,
        brand: brand,
        dimension11: locId,
        brand: brand,
        position: position,
        quantity: 1,
        price: 0,
        step: step,
        dimension3: patientStatus
    }

    if (aptDate) {
        product.variant = variant;
        product.dimension7 = tools.getDayOfWeek(aptDate);
        product.dimension10 = aptDate;
        product.metric1 = 45;
        product.dimension3 = patientStatus;
        product.metric2 = aptDate ? tools.differenceInDays(aptDate, "MM/DD/YYYY") : "";
    }

    window.dataLayer.push({ ecommerce: null });
  
    window.dataLayer.push({
      event: eventType,
  
      ecommerce: {
        checkout: {
          actionField: {
            list:list,
            step,
          },
  
          products: [
            product,
          ],
        },
      },
    });
  };
  
  export const gaPurchase = (eventType,pID, pName, locId, provID, aptDate,position,list,category,brand,variant, patientStatus) => {
    
    let correlationId = uuidv4();
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event:eventType,
  
      ecommerce: {
        purchase: {
          actionField: {
            id: correlationId,
            revenue: 0,
            tax: 0,
            shipping: 0,
            list: list,
          },
          products: [
            {
              id: pID,
              name: pName,
              category: category,
              brand: brand,
              variant: variant,
              dimension11: locId,
              dimension12: provID,
              dimension7: tools.getDayOfWeek(aptDate),
              //dimension6: aptTime,
              dimension3: patientStatus,
              dimension10: aptDate,
              metric1: 0,
              metric2: aptDate ? tools.differenceInDays(aptDate, "MM/DD/YYYY") : "",
              position: position,
              quantity: 1,
              price: 0,
            },
          ],
        },
      },
    });
  };
